import React, { Suspense, useEffect } from "react";
import _ from "lodash";
import { graphql } from "react-relay";
import {
  PreloadedQuery,
  usePreloadedQuery,
  useQueryLoader,
} from "react-relay/hooks";
import { View } from "@components/atoms/Themed";
import Loading from "@components/atoms/Loading";
import NavigationBar from "@components/molecules/NavigationBar";
import Notifications from "@components/templates/Notifications";
import { PagingNotification } from "@constants/App";
import { goBack } from "@navigation/navigate";
import { NotificationsScreenQuery } from "@generated/NotificationsScreenQuery.graphql";

const query = graphql`
  query NotificationsScreenQuery($first: Int!) {
    ...NotificationsPagination @arguments(first: $first)
  }
`;

function ScreenContent({
  queryReference,
}: {
  queryReference: PreloadedQuery<NotificationsScreenQuery>;
}) {
  const data = usePreloadedQuery<NotificationsScreenQuery>(
    query,
    queryReference
  );
  return <Notifications fragmentRef={data} />;
}

export default function NotificationsScreen(): JSX.Element {
  const [queryReference, loadQuery, disposeQuery] =
    useQueryLoader<NotificationsScreenQuery>(query);

  useEffect(() => {
    loadQuery(
      { first: PagingNotification },
      { fetchPolicy: "network-only" }
    );
    return () => {
      disposeQuery();
    };
  }, [loadQuery, disposeQuery]);

  return (
    <View style={{ flex: 1 }}>
      <NavigationBar onBack={() => goBack()} title="お知らせ" />
      <Suspense fallback={<Loading size="large" />}>
        {!_.isNil(queryReference) && (
          <ScreenContent queryReference={queryReference} />
        )}
      </Suspense>
    </View>
  );
}
